var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingTagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1281_503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.592 117H96.4131V62.7631H75.592V117Z",
    fill: "#E53323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4125 41.8027H117.115V20.9606L96.4125 20.9606V41.8027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2373 62.408V41.5659H20.937V62.408H75.2373Z",
    fill: "#E53323"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2373 20.8421V0L20.937 0V20.8421L75.2373 20.8421Z",
    fill: "#004899"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1281_503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingTagIcon);
export default __webpack_public_path__ + "static/media/setting-tag-icon.1ce71b39e0910b2e8f27f4c9bcb695fc.svg";
export { ForwardRef as ReactComponent };